import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, tap } from 'rxjs';
import { GdprDataService } from 'src/app/modules/gdpr/services/gdpr-data/gdpr-data.service';

export const gdprGuard: CanActivateFn = () => {

  const gdprDataService = inject(GdprDataService);
  const router = inject(Router);

  return gdprDataService.getAccountAreaValidation$(1).pipe(
    tap((accepted) => {
      if (!accepted) {
        router.navigate(['/consensi-aggiornati']);
      }
    }),
    map((accepted) => accepted)
  );
};
